import {
	addToRecentlyViewedProducts,
	getRecentlyViewedProducts,
	removeFromRecentlyViewedProducts
} from "../../../core/helpers/recentlyViewedProducts";
import { GETTER_CART } from "../cart/cart";

export const STATE_LOADING = "loading";
export const STATE_PRODUCTS = "products";

export const MUTATION_UPDATE_LOADING = "updateLoading";
export const MUTATION_UPDATE_PRODUCTS = "updateProducts";

export const ACTION_INIT_RECENTLY_VIEWED_PRODUCTS =
	"initRecentlyViewedProducts";
export const ACTION_GET_RECENTLY_VIEWED_PRODUCTS = "getRecentlyViewedProducts";
export const ACTION_ADD_TO_RECENTLY_VIEWED_PRODUCTS =
	"addToRecentlyViewedProducts";
export const ACTION_REMOVE_FROM_RECENTLY_VIEWED_PRODUCTS =
	"removeFromRecentlyViewedProducts";

export const GETTER_PRODUCTS = "products";

export default {
	namespaced: true,
	state: () => {
		return {
			[STATE_LOADING]: true,
			[STATE_PRODUCTS]: []
		};
	},
	getters: {
		[GETTER_PRODUCTS](state, getters, rootState, rootGetters) {
			const cart = rootGetters[`cart/${GETTER_CART}`];
			const product_ids = cart.items.map((item) => {
				return item.product_id;
			});

			return state[STATE_PRODUCTS].filter((product) => {
				return !product_ids.includes(product.id);
			});
		}
	},
	mutations: {
		[MUTATION_UPDATE_LOADING](state, loading) {
			state[STATE_LOADING] = loading;
		},
		[MUTATION_UPDATE_PRODUCTS](state, products) {
			state[STATE_PRODUCTS] = products;
		}
	},
	actions: {
		async [ACTION_INIT_RECENTLY_VIEWED_PRODUCTS](
			context,
			{ errorCallback = () => {} } = {}
		) {
			await context.dispatch(ACTION_GET_RECENTLY_VIEWED_PRODUCTS, {
				errorCallback
			});
		},
		async [ACTION_GET_RECENTLY_VIEWED_PRODUCTS](
			context,
			{ errorCallback = () => {} }
		) {
			context.commit(MUTATION_UPDATE_LOADING, true);

			try {
				const products = await getRecentlyViewedProducts();

				context.commit(MUTATION_UPDATE_PRODUCTS, products);

				context.commit(MUTATION_UPDATE_LOADING, false);
			} catch (error) {
				await errorCallback(error);
			}
		},
		async [ACTION_ADD_TO_RECENTLY_VIEWED_PRODUCTS](
			context,
			{ id, errorCallback = () => {} } = {}
		) {
			context.commit(MUTATION_UPDATE_LOADING, true);

			try {
				await addToRecentlyViewedProducts(id);

				await context.dispatch(ACTION_GET_RECENTLY_VIEWED_PRODUCTS);
			} catch (error) {
				await errorCallback(error);
			}

			context.commit(MUTATION_UPDATE_LOADING, false);
		},
		async [ACTION_REMOVE_FROM_RECENTLY_VIEWED_PRODUCTS](
			context,
			{ id, errorCallback = () => {} } = {}
		) {
			context.commit(MUTATION_UPDATE_LOADING, true);

			try {
				await removeFromRecentlyViewedProducts(id);

				await context.dispatch(ACTION_GET_RECENTLY_VIEWED_PRODUCTS);
			} catch (error) {
				await errorCallback(error);
			}

			context.commit(MUTATION_UPDATE_LOADING, false);
		}
	}
};
